import { SummaryList } from 'nhsuk-react-components';
import SummaryRow from 'components/SummaryTable/Campaign/SummaryRow.tsx';
import useFetchTeamDetails from 'queries/fetch/fetchTeamDetails.ts';

interface TeamDetailsSectionProps {
  teamId: string;
}

function TeamDetailsSection({ teamId }: TeamDetailsSectionProps) {
  const teamDetails = useFetchTeamDetails({ teamId });

  return (
    <div className="nhsuk-u-margin-top-6">
      <h4>Team details</h4>
      <SummaryList>
        <SummaryRow
          itemKey="team-name"
          itemName="Team name"
          itemValue={teamDetails.data?.team.TEAM_NAME ?? teamId}
          canUpdate={false}
        />
      </SummaryList>
    </div>
  );
}

export default TeamDetailsSection;
